export const ContentTypeIDs = {
  CENTER_IMAGE: 'center-image',
  CENTER_TEXT: 'center-text',
  CENTER_TEXT_TWO: 'center-text-two',
  DOUBLE_VIDEO: 'double-video',
  FULL_IMAGE: 'full-image',
  LINK: 'link',
  LINK_MINI: 'link-mini',
  VIDEO: 'video',
  GRID: 'grid',
  COPY_PROJECT: 'copy-project',
};
